import axios from "axios";
import { API_BASE_URL } from "../constants/api.constants";

export function AxiosSetup() {
  if (!API_BASE_URL) {
    console.error(
      "REACT_APP_API_URL is not set. API calls will fail. " +
        "Set REACT_APP_API_URL=https://cnc-backend-production-4171.up.railway.app/api/v1 in .env.staging and rebuild."
    );
  } else if (!/^https?:\/\//i.test(API_BASE_URL)) {
    console.error(
      `REACT_APP_API_URL must start with http:// or https://. Got: "${API_BASE_URL}". ` +
        "A relative value causes requests to hit the frontend domain and return 404."
    );
  }

  axios.defaults.baseURL = API_BASE_URL;
}
